export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8757.e026d811.jpg";